var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// C:/Source/hackathon/hackathon/web-app/node_modules/core-js/modules/_user-agent.js
// module id = ../../../node_modules/core-js/modules/_user-agent.js
// module chunks = 0